import request from 'utils/request';

export default async function fetchZips(
  index = 1,
  limit = 10,
  filter = {}
): Promise<any> {
  try {
    const { data: result } = await request(
      `/lineDriveService/mfgRepDetails/findAll`,
      {
        method: 'GET',
        body: {
          index: index - 1,
          limit,
          ...filter
        }
      }
    );

    return result;
  } catch (error) {
    console.log(error);
  }
}
